var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:{
    'tag--info': _vm.status == '-1',
    'tag--success': _vm.status == '0',
    'tag--danger': _vm.status == '1',
    'tag--large': true
  }},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }